// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c32ead8","893":"75076a62"}[chunkId] + ".chunk.js";
};